import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import { isEmpty } from './core/utils/ValidForm';

const AppSubmenu = (props) => {
    const [activeIndex, setActiveIndex] = useState(null);

    const onMenuItemClick = (event, item, index) => {
        if (item.disabled) {
            event.preventDefault();
            return true;
        }

        if (item.command) {
            item.command({ originalEvent: event, item: item });
        }

        if (index === activeIndex) setActiveIndex(null);
        else setActiveIndex(index);

        if (props.onMenuItemClick) {
            props.onMenuItemClick({
                originalEvent: event,
                item: item,
            });
        }
    };

    const renderLinkContent = (item) => {
        let submenuIcon = item.items && (
            <i className="pi pi-fw pi-angle-down menuitem-toggle-icon"></i>
        );
        let badge = item.badge && <span className="menuitem-badge">{item.badge}</span>;

        const getIconMaterial = () => {
            return item.iconMaterial ? item.iconMaterial : '';
        };

        return (
            <React.Fragment>
                {item.icon ? <i className={item.icon}></i> : getIconMaterial()}
                <span>{item.label}</span>
                {submenuIcon}
                {badge}
            </React.Fragment>
        );
    };

    const renderLink = (item, i) => {
        let content = renderLinkContent(item);

        if (item.to) {
            if (item.label !== null && item?.visibleOnMenu) {
                return (
                    <NavLink
                        activeClassName="active-route"
                        to={item.to}
                        onClick={(e) => onMenuItemClick(e, item, i)}
                        exact
                        target={item.target}
                    >
                        {content}
                    </NavLink>
                );
            }
        } else {
            return (
                <a
                    href={item.url}
                    onClick={(e) => onMenuItemClick(e, item, i)}
                    target={item.target}
                >
                    {content}
                </a>
            );
        }
    };

    let items =
        props.items &&
        props.items.map((item, i) => {
            let active = activeIndex === i;
            let styleClass = classNames(item.badgeStyleClass, {
                'active-menuitem': active && !item.to,
            });

            return (
                <li className={styleClass} key={i}>
                    {item.items && props.root === true && <div className="arrow"></div>}
                    {renderLink(item, i)}
                    <CSSTransition
                        classNames="p-toggleable-content"
                        timeout={{ enter: 1000, exit: 450 }}
                        in={active}
                        unmountOnExit
                    >
                        <AppSubmenu items={item.items} onMenuItemClick={props.onMenuItemClick} />
                    </CSSTransition>
                </li>
            );
        });

    return items ? <ul className={props.className}>{items}</ul> : null;
};

export const AppMenu = (props) => {
    const [modals, setModals] = useState([]);

    useEffect(() => {
        const getModalsVisible = (lista) => {
            let retorno = [];
            for (let i = 0; i < lista.length; i++) {
                if (Array.isArray(lista[i]?.items)) {
                    const novaLista = getModalsVisible(lista[i]?.items);
                    if (novaLista.length > 0) {
                        retorno.push({ ...lista[i], items: novaLista });
                    }
                } else if (lista[i]?.visibleOnRouter && !isEmpty(lista[i]?.label)) {
                    retorno.push(lista[i]);
                }
            }
            return retorno;
        };
        setModals(getModalsVisible(props?.model ?? []));
    }, []);

    return (
        <div className="layout-menu-container" style={{ textAlign: 'left' }}>
            <AppSubmenu
                items={modals}
                className="layout-menu"
                onMenuItemClick={props.onMenuItemClick}
                root={true}
            />
        </div>
    );
};
